import { usePageContext } from '~/providers/page-context';

type ClickoutService = 'OFFERS_CLICKOUT_SERVICE' | 'LEGACY_CLICKOUT_SERVICE';

export const useOffersClickoutServiceProps = (gtmIdFromProps?: string, fullPageUrlFromProps?: string) => {
  // Always get PageProvider context (available in all routes via body.tsx)
  const pageContext = usePageContext();

  // The PageProvider context has all the data we need
  const {
    ENV,
    currentPathWithRepub,
    deviceType,
    fullPageUrl: fullPageUrlFromContext,
    gtmId: gtmIdFromContext,
  } = pageContext;
  const { CLICKOUT_URL } = ENV || {};

  const clickoutServiceUrl = `${CLICKOUT_URL}/offer/clickout`;

  // Use gtmId from props if provided, otherwise fall back to pageContext
  const gtmId = gtmIdFromProps ?? gtmIdFromContext;

  // Use fullPageUrl from props if provided, otherwise fall back to pageContext
  const fullPageUrl = fullPageUrlFromProps ?? fullPageUrlFromContext;

  return {
    clickoutService: 'OFFERS_CLICKOUT_SERVICE' as ClickoutService,
    clickoutServiceUrl,
    pageUrl: currentPathWithRepub,
    deviceType,
    gtmId,
    fullPageUrl,
  };
};
